<template>
    <div id="video-player-area" @fullscreenchange="onFullscreenChange" class="flex w-full justify-center items-center"
        :style="{ height: `calc(100vh - ${videoPlayerAreaHeightOffset} - ${onvifAreaSize.y})` }"
        style="background-color: black;">
        <!-- カメラ表示エリア -->
        <div class="flex w-full justify-center items-center" :style="{ width: videoPlayerWidthByHeight }"
            @click="mode === 'history' && onVideoClick">
            <template v-if="onvifEnable && onvifActive">
                <MediaMTXWebRTCReader v-if="isWebRTC && mode !== 'history'" :whep-url="webrtcUrl"
                    :login="camera.webrtcLoginId" :password="camera.webrtcPassword" style="width: 100%;" />
                <video-player v-else id="live-video-player" class="media-video-player card-video vjs-big-play-centered"
                    ref="videoPlayer" :options="playerOptions"
                    :style="{ 'min-width': zoomSize, 'min-height': zoomSize, 'margin-bottom': (camera.movieType === CAMERA_MOVIE_TYPE.SAFIE && mode === 'history') ? '40px' : '0', }"
                    @ready="onPlayerReadied" @play="onPlayerPlay" @pause="onPlayerPause" @error="onPlayerError"
                    @ended="onPlayerEnded" />
            </template>
            <template v-else>
                <video-player id="live-video-player" class="media-video-player card-video vjs-big-play-centered"
                    ref="videoPlayer" :options="playerOptions"
                    :style="{ 'min-width': zoomSize, 'min-height': zoomSize, 'margin-bottom': (camera.movieType === CAMERA_MOVIE_TYPE.SAFIE && (mode === 'history' && isHistoryPlayback)) ? '40px' : '0', }"
                    @ready="onPlayerReadied" @play="onPlayerPlay" @pause="onPlayerPause" @error="onPlayerError"
                    @ended="onPlayerEnded" v-if="mode === 'realtime' || (mode === 'history' && !isHistoryPlayback)" />
                <video-player id="history-video-player" class="media-video-player card-video vjs-big-play-centered"
                    ref="videoPlayer" :options="playerOptions"
                    :style="{ 'min-width': zoomSize, 'min-height': zoomSize, 'margin-bottom': (camera.movieType === CAMERA_MOVIE_TYPE.SAFIE && (mode === 'history' && isHistoryPlayback)) ? '40px' : '0', }"
                    @ready="onPlayerReadied" @play="onPlayerPlay" @pause="onPlayerPause" @error="onPlayerError"
                    @ended="onPlayerEnded" v-if="mode === 'history' && isHistoryPlayback" />
            </template>

            <!-- コントロールバーエリア -->
            <div class="w-full m-0 p-0" style="position: absolute; bottom: 0; right: 0;"
                :style="{ display: (camera && onvifEnable && onvifActive) ? 'none' : 'block', }">
                <camera-player-control ref="playBackControls" :current="currentMomentValueOf"
                    :start="playStartMomentValueOf"
                    :mode="mode === 'realtime' || (mode === 'history' && !isHistoryPlayback) ? 'realtime' : 'history'"
                    :fps="fps" :thumbnails="thumbnails" @onPlay="onPlay" @onChangeVolume="onChangeVolume"
                    @setFPS="setFPS" @onChangeSeek="onChangeSeek" @onChangeFullscreen="setFullscreen" />
            </div>
            <!-- LIVEマーク: リアルタイムのみ -->
            <div v-if="mode !== 'history' || (mode === 'history' && !isHistoryPlayback)">
                <div class="flex"
                    style="position: absolute; bottom: 0; left: 0px; color: white; background-color: #82828200; padding: 0.4rem 0.6rem 0.8rem 0.6rem;"
                    :style="{ display: (camera && onvifEnable && onvifActive) ? 'none' : 'block', }">
                    <span style="color:white; margin-left: 1rem;">LIVE</span>
                </div>
            </div>
        </div>
        <!-- Zoomボタン: 履歴 のみ -->
        <div v-if="mode === 'history' && isHistoryPlayback">
            <div class="flex"
                style="position: absolute; bottom: 0px; left: 280px; color: white; background-color: #82828200; padding: 0.4rem 0.6rem 0.8rem 0.6rem;">
                <feather-icon icon="ZoomOutIcon" svgClasses="h-6 w-6" style="color:white; cursor: pointer;"
                    @click="zoomClicked('minus')" />
                <div v-for="(zoomValue, index) in zoomList" :key="index" @click="zoomClicked(zoomValue)"
                    :style="{ 'color': (targetZoom === zoomValue) ? '#48A0F4' : 'white', 'margin': '0 0.1rem' }">
                    {{ targetZoom === zoomValue ? '●' : '○' }} </div>
                <feather-icon icon="ZoomInIcon" svgClasses="h-6 w-6" style="color: white; cursor: pointer;"
                    @click="zoomClicked('plus')" />
            </div>
        </div>
    </div>
</template>

<script>
import { videoPlayer } from "vue-videojs7";
import CameraPlayerControl from "./CameraPlayerControl.vue";
import { CAMERA_MOVIE_TYPE } from "@/config/const";
import MediaMTXWebRTCReader from "./MediaMTXWebRTCReader.vue";

export default {
    components: { videoPlayer, CameraPlayerControl, MediaMTXWebRTCReader },
    props: {
        camera: Object,
        mode: String,
        onvifEnable: Boolean,
        onvifActive: Boolean,
        onFullscreenChange: Function,
        videoPlayerAreaHeightOffset: String,
        onvifAreaSize: Object,
        videoPlayerWidthByHeight: String,
        playerOptions: Object,
        zoomSize: String,
        zoomList: Array,
        targetZoom: Number,
        zoomClicked: Function,
        currentMomentValueOf: Number,
        playStartMomentValueOf: Number,
        fps: Number,
        thumbnails: Array,
        onPlay: Function,
        onChangeVolume: Function,
        setFPS: Function,
        onChangeSeek: Function,
        setFullscreen: Function,
        onPlayerReadied: Function,
        onPlayerPlay: Function,
        onPlayerPause: Function,
        onPlayerError: Function,
        onPlayerEnded: Function,
        onVideoClick: Function,
        isWebRTC: Boolean,
        webrtcUrl: String,
        isHistoryPlayback: Boolean,
    },
    data() {
        return { CAMERA_MOVIE_TYPE };
    },
};
</script>

<style lang="scss">
.live-camera-area {
    position: relative;
}

.live-camera-area p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    padding: 0;
    color: white;
    z-index: 5;
}

.live-camera-area button {
    z-index: 5;
    position: absolute;
    top: 80%;
    left: 50%;
    margin-left: 0;
    transform: translate(-50%, -50%);
}
</style>